import ClientDetail from './ClientDetail.vue';

export default ClientDetail;
